import { memo } from 'react'

export const AsiajyeStock_Sidebar = memo(function AsiajyeStock_Sidebar() {
  return <div>股票版</div>
})
